import { MessageCircle } from "lucide-react";
import { companyInfo } from "../data/mock";

export const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent("Hi, I'm interested in your machines. Please provide more information.");
    window.open(`https://wa.me/${companyInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110 group animate-bounce"
      aria-label="Contact us on WhatsApp"
      style={{ animationDuration: '2s' }}
    >
      {/* Pulse ring effect */}
      <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
      
      <MessageCircle className="w-8 h-8 relative z-10" />
      
      <span className="absolute right-20 bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg">
        💬 Get Instant Quote on WhatsApp
      </span>
    </button>
  );
};
